import { SET_SCROLL_ELEMENT } from '../reducers/scrollReducer'

export const setScrollElement = element => dispatch => {
    return dispatch({
        type: SET_SCROLL_ELEMENT,
        payload: element
    })
}
